import {getWorkStagesUrl} from '../api.config';
import {WorkStagesServiceData} from '../../shared/types/form.types';
import axiosInstance from '../protected';

export const WorkStagesService = {
  async createServicePath(data: WorkStagesServiceData) {
    return await axiosInstance.post<WorkStagesServiceData>(getWorkStagesUrl('/createOrUpdateServicePath'), data);
  },

  async getServicePathByServiceName(serviceName: string, options?: {signal?: AbortSignal}) {
    return await axiosInstance.get(getWorkStagesUrl('/getServicePathByServiceName'), {
      params: {serviceName},
      signal: options?.signal
    });
  },
};
